<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-app>
        <resizable-page>
          <template v-slot:table="tableProps">
            <v-card>
              <!-- <v-card-title>
      Client Master List
    </v-card-title> -->
              <v-card-title>
                <v-btn
                  color="primary"
                  dark
                  class="ma-2"
                  @click="editBulkSpj"
                  v-if="check_object_value(division,'name',['Update Bulk Spj Rental','Admin'])"
                >
                  Edit Bulk SPJ
                </v-btn>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="ma-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Export To XLS
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item link>
                      <!-- <downloadExcel
                        class="btn"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                        :fetch="
                          () => {
                            return dataExportBefore('all');
                          }
                        "
                      >
                        All Record
                      </downloadExcel> -->
                      <div class="btn" @click="exportAllXls()"> All Record </div>
                      <downloadExcel
                        hidden
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                        :fetch="
                          () => {
                            return dataExport(exportAllData);
                          }
                        "
                      >
                      <button type="button" 
                        ref="btnDownloadAllExcell" class="btn"></button>
                      </downloadExcel>
                    </v-list-item>
                    <v-list-item link>
                      <downloadExcel
                        class="btn"
                        :data="exportDisplayedPage"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                      >
                        Displayed record
                      </downloadExcel>
                    </v-list-item>
                    <v-list-item link>
                      <div class="btn" @click="exportAllFilteredXls()"> All filtered record </div>
                        <downloadExcel
                          hidden
                          :fields="field_export"
                          :worksheet="worksheetName"
                          :name="fileName"
                          :fetch="
                            () => {
                              return dataExport(exportAllData);
                            }
                          "
                        >
                        <button type="button" 
                          ref="btnDownloadAllFilteredExcell" class="btn"></button>
                        </downloadExcel>
                      <!-- <downloadExcel
                        class="btn"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                        :fetch="
                          () => {
                            return dataExportBefore('filter');
                          }
                        "
                      >
                        All filtered record
                      </downloadExcel> -->
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <div class="d-flex flex-wrap">
                  <!-- filter date -->
                  <!-- <div class="shadow d-flex">
                    <div class="mt-5 mx-5">
                      <input
                        type="date"
                        class="form-control"
                        placeholder="Username"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                    <p class="mt-5 fs-small">s/d</p>
                    <div class="mt-5 mx-5">
                      <input
                        type="date"
                        class="form-control"
                        placeholder="Username"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                    <v-btn
                      :disabled="!search"
                      class="mt-5"
                      small
                      color="primary"
                    >
                      <v-icon>mdi-calendar-filter</v-icon>
                    </v-btn>
                  </div> -->
                  <v-select
                    style=" max-width: 150px;"
                    :items="option_filter"
                    label="Select"
                    v-model="searchCategory"
                    @change="search = ''"
                    item-text="text"
                    item-value="value"
                    class="ma-2"
                    hide-details
                  >
                  </v-select>
                  <v-text-field
                    :disabled="!searchCategory"
                    v-model="search"
                    label="Search"
                    class="ma-2"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                  <v-btn
                    :disabled="!search"
                    class="mt-5"
                    small
                    color="primary"
                    @click="searchButton"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="searchValue"
                    class="mt-5 ml-1"
                    dark
                    small
                    color="red"
                    @click="clearSearchButton"
                    >Clear</v-btn
                  >
                </div>
                <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->
              </v-card-title>
              <v-data-table
                mobile-breakpoint
                :headers="headers"
                :items="table"
                :loading="loadTable"
                loading-text="Loading... Please wait"
                @current-items="getFiltered"
                ref="vTable"
                :height="tableProps.tableHeight"
                fixed-header
                :options.sync="options"
                :server-items-length="totalDataTable"
                :page="page"
                :pageCount="numberOfPages"
                single-expand
                show-expand
                :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
              >
                <!-- <template v-slot:[`header.spj_business_unit`]="{ header }">
      <v-select
        style=" font-size:10px;"
        :items="optionBusinessUnit"
        :label="header.text"
        v-model="valueBusinessUnit"
        @change="getList"
        item-text="business_unit_name"
        item-value="id"
        class="ma-2"
        hide-details
      >
      </v-select>
    </template> -->

                <template v-slot:[`header.spj_status`]="{ header }">
                  <v-select
                    style=" font-size:10px;"
                    :items="optionStatus"
                    :label="header.text"
                    v-model="valueStatus"
                    @change="getList"
                    item-text="text"
                    item-value="value"
                    class="ma-2"
                    hide-details
                  >
                  </v-select>
                </template>

                <template v-slot:[`header.pko_status`]="{ header }">
                  <v-select
                    style=" font-size:10px;"
                    :items="optionPkoStatus"
                    :label="header.text"
                    v-model="valuePkoStatus"
                    @change="getList"
                    item-text="text"
                    item-value="value"
                    class="ma-2"
                    hide-details
                  >
                  </v-select>
                </template>

                <!-- <template v-slot:[`item.spj_business_unit`]="{ item }">
      {{ item.spj_pko_data.vehicle.vehicle_business_unit.business_unit_name }}
      </template> -->

                <template v-slot:[`item.pko_no`]="{ item }">
                  {{ item.spj_pko_data.pko_no }}
                </template>
                <template v-slot:[`item.pko_status`]="{ item }">
                  <span v-if="item.spj_pko_data.current_status.status == 0">Registered</span>
                  <span v-if="item.spj_pko_data.current_status.status == 1">Waiting Approval</span>
                  <span v-if="item.spj_pko_data.current_status.status == 2">Rejected</span>
                  <span v-if="item.spj_pko_data.current_status.status == 3">Active</span>
                  <span v-if="item.spj_pko_data.current_status.status == 4">Payment Completed</span>
                  <span v-if="item.spj_pko_data.current_status.status == 5">Terminate By Payment</span>
                </template>
                
                <template v-slot:[`item.spj_weekly_installment`]="{ item }">
                  <span style="float:left;">Rp.</span>
                  <span style="float:right;">{{
                    formatPrice(item.spj_weekly_installment)
                  }}</span>
                </template>

                <template v-slot:[`item.spj_penalty`]="{ item }">
                  <span style="float:left;">Rp.</span>
                  <span style="float:right;">{{
                    formatPrice(item.spj_penalty)
                  }}</span>
                </template>

                <template v-slot:[`item.payment_amount`]="{ item }">
                  <span style="float:left;">Rp.</span>
                  <span style="float:right;">{{
                    formatPrice(item.payment_amount)
                  }}</span>
                </template>
                <template v-slot:[`item.spj_door_no`]="{ item }">
                  <span v-if="item.spj_pko_data.vehicle">{{
                    item.spj_pko_data.vehicle.vehicle_door_no
                  }}</span>
                </template>
                <template v-slot:[`item.spj_kip_no`]="{ item }">
                  <span v-if="item.spj_pko_data.driver">{{
                    item.spj_pko_data.driver.driver_no
                  }}</span>
                </template>
                <template v-slot:[`item.spj_driver_name`]="{ item }">
                  <span v-if="item.spj_pko_data.driver">{{
                    item.spj_pko_data.driver.driver_name
                  }}</span>
                </template>
                <template v-slot:[`item.spj_total_payable`]="{ item }">
                  <span style="float:left;">Rp.</span>
                  <span style="float:right;">{{
                    formatPrice(item.spj_weekly_installment + item.spj_penalty)
                  }}</span>
                </template>
                <template v-slot:[`item.spj_status`]="{ item }">
                  <div v-if="item.spj_current_status">
                    <span v-if="item.spj_current_status.status == 0"
                      >Registered</span
                    >
                    <span v-if="item.spj_current_status.status == 1"
                      >Partially Paid</span
                    >
                    <span v-if="item.spj_current_status.status == 2">Paid</span>
                    <span v-if="item.spj_current_status.status == 3"
                      >Unpaid</span
                    >
                    <span v-if="item.spj_current_status.status == 4"
                      >Active</span
                    >
                  </div>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td class="pa-5" :colspan="headers.length">
                    <!-- Faktur are closed: -->
                    <md-table class="ma-5">
                      <md-table-row>
                        <md-table-head style="text-align: center;"
                          ><b>No</b></md-table-head
                        >
                        <md-table-head style="text-align: center;"
                          ><b>Payment Date</b></md-table-head
                        >
                        <md-table-head style="text-align: center;"
                          ><b>Payment Method</b></md-table-head
                        >
                        <md-table-head style="text-align: center;"
                          ><b>Amount</b></md-table-head
                        >
                        <md-table-head style="text-align: center;"
                          ><b>Status</b></md-table-head
                        >
                      </md-table-row>
                      <md-table-row
                        v-for="(items, index) in item.payment_history"
                        :key="index"
                      >
                        <md-table-cell style="text-align: center;">{{
                          index + 1
                        }}</md-table-cell>
                        <md-table-cell style="text-align: center;">{{
                          items.payment_at
                        }}</md-table-cell>
                        <md-table-cell style="text-align: center;">
                          <span v-if="items.payment_method == 1">Cash</span>
                          <span v-if="items.payment_method == 2">Transfer</span>
                          <span v-if="items.payment_method == 3">Debit</span>
                          <span v-if="items.payment_method == 4"
                            >Virtual Account</span
                          >
                        </md-table-cell>
                        <md-table-cell style="text-align: center;">
                          <span style="float:left;">Rp.</span>
                          <span style="float:right;">{{
                            formatPrice(items.payment_receive_amount)
                          }}</span>
                        </md-table-cell>
                        <md-table-cell style="text-align: center;"
                          >Success</md-table-cell
                        >
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell colspan="4" style="font-weight:bold;"
                          >Total Paid Amount</md-table-cell
                        >
                        <md-table-cell style="text-align: center;">
                          <span style="float:left;">Rp.</span>
                          <span style="float:right;">{{
                            formatPrice(item.payment_amount)
                          }}</span>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </td>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        x-small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark x-small>
                          mdi-format-list-bulleted-square
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-if="role.update"
                        v-on:click="editSpj(item.id)"
                      >
                        <v-list-item-title x-small>Edit Spj</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>

                <!-- <template v-slot:[`item.actions`]="{ item }">
      
        <v-menu  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            
          >
            <v-icon dark x-small>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item  @click="modalOpenEditFormCity(item.id)">
            <v-list-item-title x-small>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item  @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template> -->
              </v-data-table>
            </v-card>
          </template>
        </resizable-page>
      </v-app>
    </div>
    <modal ref="modalEditSpj" class="coba">
      <template v-slot:header>
        <div>
          <h3>Edit SPJ</h3>
        </div>
        <md-button class="md-dense md-round md-icon-button" @click="modalCloseEditSpj()"><md-icon>close</md-icon></md-button>
      </template>

      <template v-slot:body>
        <edit-spj :data_id="$refs.modalEditSpj.data" />
      </template>
    </modal>
    <modal ref="modalEditBulkSpj" class="coba">
      <template v-slot:header>
        <div>
          <h3>Edit Bulk SPJ</h3>
        </div>
        <md-button class="md-dense md-round md-icon-button" @click="modalCloseEditBulkSpj()"><md-icon>close</md-icon></md-button>
      </template>

      <template v-slot:body>
        <edit-bulk-spj  />
      </template>
    </modal>
  </div>
</template>

<script>
import vuetify from "@/plugins/vuetify";
import { ResizablePage } from "@/components";
import Vue from "vue";
import EditSpj from "@/pages/Dashboard/Fms/Spj/Modal/EditSpj.vue";
import EditBulkSpj from "@/pages/Dashboard/Fms/Spj/Modal/EditBulkSpj.vue";
import VueSweetalert2 from "vue-sweetalert2";
import { Modal } from "@/components";
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";

Vue.use(VueSweetalert2);
const toLower = (text) => {
  var rt = "";
  if (text) {
    rt = text.toString().toLowerCase();
  }
  return rt;
};
export default {
  components: {
    downloadExcel: JsonExcel,
    ResizablePage,
    "edit-spj": EditSpj,
    "edit-bulk-spj": EditBulkSpj,
    Modal,
  },
  vuetify,
  computed: {
    headers() {
      const headers = [
        // { text: "Action", value: "actions", align: "start", sortable: false },
        { text: "", value: "data-table-expand" },

        // { text: 'No', value: 'spj_sequence_no' },
        // { text: "Business Unit", value: "spj_business_unit", sortable: false },
        { text: "PKO No", value: "pko_no" },
        { text: "PKO Status", value: "pko_status", sortable: false, width: "150"  },
        { text: "Spj No", value: "spj_no" },
        { text: "Vehicle No", value: "spj_door_no", width: "150" },
        { text: "KIP No", value: "spj_kip_no" },
        { text: "Driver Name", value: "spj_driver_name", width: "150" },
        { text: "Weekly", value: "spj_weekly_installment", width: "150" },
        { text: "Penalty", value: "spj_penalty", width: "150" },
        {
          text: "Total Payable",
          value: "spj_total_payable",
          sortable: false,
          width: "150",
        },
        {
          text: "Paid Amount",
          value: "payment_amount",
          sortable: false,
          width: "150",
        },
        { text: "Start Date", value: "spj_start_date", width: "150" },
        { text: "Due Date", value: "spj_due_date", width: "150" },
        { text: "Status", value: "spj_status", sortable: false },
        { text: "Remark", value: "spj_remarks" },
      ];
      console.log(this.role);
      if (this.role.update) {
        headers.unshift({
          text: "Action",
          value: "actions",
          align: "start",
          sortable: false,
        });
      }

      return headers;
    },
  },
  data: () => ({
    // optionBusinessUnit: null,
    // valueBusinessUnit:0,
    SwallAllExport: null,
    loadTable: false,
    page: 1,
    options: {},
    totalDataTable: 0,
    numberOfPages: 0,
    searchValue: null,
    searchCategory: null,
    option_filter: [
      { text: "Spj No", value: "spj_no" },
      { text: "PKO No", value: "pko_no" },
      { text: "Vehicle No", value: "spj_door_no" },
      { text: "KIP No", value: "spj_kip_no" },
      // { text: 'Weekly', value: 'spj_weekly_installment'  },
      // { text: 'Penalty', value: 'spj_penalty' },
      { text: "Start Date", value: "spj_start_date" },
      { text: "Start Date To", value: "spj_start_date_to" },
      { text: "Due Date", value: "spj_due_date" },
      { text: "Due Date To", value: "spj_due_date_to" },
      { text: "Remark", value: "spj_remarks" },
      // { text: 'Status', value: 'pko_status'},
    ],
    valueStatus: "",
    optionStatus: [
      { text: "All", value: "" },
      { text: "Paid", value: "2" },
      { text: "Partially Paid", value: "1" },
      { text: "Registered", value: "0" },
      { text: "Unpaid", value: "3" },
      { text: "Active", value: "4" },
    ],
    valuePkoStatus: "",
    optionPkoStatus: [
      { text: "All", value: "" },
      { text: "Active", value: "3" },
      { text: "Payment Completed", value: "4" },
      { text: "Terminate By Payment", value: "5" },
    ],
    division: null,
    role: "",
    search: "",
    table: [],
    worksheetName: "SPJ",
    fileName: "SPJ.xls",
    exportDisplayedPage: [],
    exportAllFitered: [],
    field_export: {
      // spj_business_unit : 'spj_business_unit',
      pko_no: "pko_no",
      pko_status: "pko_status",
      spj_no: "spj_no",
      door_no: "door_no",
      driver_no: "driver_no",
      driver_name: "driver_name",
      spj_weekly_installment: "spj_weekly_installment",
      spj_penalty: "spj_penalty",
      spj_total_payable: "spj_total_payable",
      paid_amount: "payment_amount",
      spj_start_date: "spj_start_date",
      spj_due_date: "spj_due_date",
      spj_remarks: "spj_remarks",
      created_at: "created_at",
      updated_at: "updated_at",
    },
  }),

  watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
    //get list role dan permission current user
    this.role = await this.$store.getters["role_permission/route_filter"];
    var me = await this.$store.getters["profile/me"]
    this.division = me.role_name
    // this.onMounted()
    this.getList();
    this.mounted = false;
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    // async onMounted(){
    //     await this.$store.dispatch("fms_business_unit/list");
    //    this.optionBusinessUnit = await this.$store.getters["fms_business_unit/list"];
    //     this.optionBusinessUnit.unshift({business_unit_name:"All",id:0});

    //  },

    async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }

   

      if (this.valueStatus != "") {
        if (query.filter) {
          Object.assign(query.filter, { spj_status: this.valueStatus });
        } else {
          query.filter = { spj_status: this.valueStatus };
        }
      }

      if (this.valuePkoStatus != "") {
        if (query.filter) {
          Object.assign(query.filter, { pko_status: this.valuePkoStatus });
        } else {
          query.filter = { pko_status: this.valuePkoStatus };
        }
      }

      await this.$store.dispatch("fms_spj/list", query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
      this.table = await this.$store.getters["fms_spj/list"];
      var pageMeta = await this.$store.getters["fms_spj/page"];
      // }
      // else{
      //   this.table = []
      // }

      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },
    check_object_value(array, key, value) {
        //return array.some(object => object[key] === value);
        return array?array.some(object => value.includes(object[key])):null;
        },
    editBulkSpj() {
      console.log();
      this.$refs.modalEditBulkSpj.openModal();
    },

    modalCloseEditBulkSpj() {
      this.getList();
      this.$refs.modalEditBulkSpj.closeModal();
    },

    editSpj(id) {
      console.log(id);
      this.$refs.modalEditSpj.openModal({ id: id });
    },

    modalCloseEditSpj() {
      this.getList();
      this.$refs.modalEditSpj.closeModal();
    },

    searchButton() {
      this.searchValue = this.search;
      this.getList();
    },
    clearSearchButton() {
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
    },

    async exportAllXls(){
      //buka swal
     Swal.fire({
                title: 'Please Wait !',
                html: "<div id='save-popup-icon'></div><span id='save-popup-message'></span>",
                allowOutsideClick: false,
                showCancelButton: true,
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
                customClass: {
                  actions: 'vertical-buttons-sweetalert',
                  cancelButton: 'top-margin-sweetalert'
                }
            }).then((result) => {
              if (result.isDismissed) {
                return
              }
            })
     //query pertama
      var query = { page: { number: 1, size: 1 } };
            await this.$store.dispatch("fms_spj/list", query);
            var pageMeta = await this.$store.getters["fms_spj/page"];
            var dataFirst = await this.$store.getters["fms_spj/list"]

            //ambil data paling akhir
            var query = { page: { number: pageMeta['last-page'], size: 1 } };
            await this.$store.dispatch("fms_spj/list", query);
            var datalast = await this.$store.getters["fms_spj/list"]

            //set tanggal pertama dan tanggal terakhir
            var startDate = this.$moment(dataFirst[0].created_at.substring(0,7));
            var endDate = this.$moment(datalast[0].created_at.substring(0,7));
            var listRange = [endDate.format('YYYY-MM')];

            //while untuk mendapatkan list bulan berdasarkan tanggal awal dan akhir
            while (endDate.isBefore(startDate)) {
              endDate = endDate.add(1, 'month');
              listRange.push(endDate.format('YYYY-MM'));
            }
            console.log(listRange)
            //untuk menghitung progress export perbulanya
            var countMonth = 1;
            //loop berdasarkan list bulan
            for (const yearMonth of listRange) { 

                console.log(yearMonth);

                //ambil data berdasarkan bulan dengan di pecah per 100
                var query = { page: { number: 1, size: 100 } };
                query.filter = { created_at_month_year: yearMonth };
                await this.$store.dispatch("fms_spj/list", query);
               var dataAll  = await this.$store.getters["fms_spj/list"]
                // console.log(dataAll)
                var pageMeta = await this.$store.getters["fms_spj/page"];
                // console.log(pageMeta['last-page'])
                //loop berdasarkan jumlah page
                for(let i=2; i < pageMeta['last-page'] + 1; i++){
                  
                  console.log('tahap '+i)
                  var query = { page: { number: i, size: 100 } };
                  query.filter = { created_at_month_year: yearMonth };
                  await this.$store.dispatch("fms_spj/list", query);
                  var dataloop = await this.$store.getters["fms_spj/list"]
                  dataAll = dataAll.concat(dataloop)

                  //update tampilan informasi di swal untuk memunculkan progress
                  let popupTextElement = document.getElementById("save-popup-message");
                   if(popupTextElement){
                     let export_text = "Export "+countMonth+"/"+listRange.length+" Month"

                     let export_percentage = (i/pageMeta['last-page']*100).toFixed(2)+"%"
                   popupTextElement.innerHTML = export_text+"</br> <progress  value='"+i+"' max='"+pageMeta['last-page']+"'></progress>";
                   }
                   else{
                     //bagian ini terpanggil jika tombol cancel di swal tertekan
                     this.fileName = "SPJ.xls"
                     return
                   }
                }
                //set file name berdsarkan buan dan tahun
                this.fileName = "SPJ "+yearMonth +".xls"
                this.exportAllData = dataAll
                //click tombol component export to excell
                const elem = this.$refs.btnDownloadAllExcell
                elem.click()
                countMonth++;


                
            }
            //tutup swal jika prosess looping selesai
            //  Swal.close();
             this.SwallAllExport = Swal;
             //set kembali ke default nama filename
            this.fileName = "SPJ.xls"
            
    },

    async exportAllFilteredXls(){
      //buka swal
      
      this.loadingAllExport = true
     Swal.fire({
                title: 'Please Wait !',
                html: "<div id='save-popup-icon'></div><span id='save-popup-message'></span>",
                allowOutsideClick: false,
                showCancelButton: true,
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
                customClass: {
                  actions: 'vertical-buttons-sweetalert',
                  cancelButton: 'top-margin-sweetalert'
                }
            }).then((result) => {
              if (result.isDismissed) {
                return
              }
            })
            //query pertama
            var query = {};
          
            const {sortBy, sortDesc } = this.options;

                if (sortBy.length != 0) {
                    var sort = sortBy[0];
                    if (sortDesc[0]) {
                      sort = "-" + sortBy[0];
                    }
                    query.sort = sort;
                  }

                if (this.searchValue && this.searchCategory) {
                   if (query.filter) {
                    Object.assign(query.filter, {
                      [this.searchCategory]: this.searchValue,
                    });
                  } else {
                    query.filter = { [this.searchCategory]: this.searchValue };
                  }
                }

                if (this.valueStatus != "") {
                    if (query.filter) {
                      Object.assign(query.filter, { spj_status: this.valueStatus });
                    } else {
                      query.filter = { spj_status: this.valueStatus };
                    }
                  }

                  if (this.valuePkoStatus != "") {
                    if (query.filter) {
                      Object.assign(query.filter, { pko_status: this.valuePkoStatus });
                    } else {
                      query.filter = { pko_status: this.valuePkoStatus };
                    }
                  }
                //ambil data berdasarkan bulan dengan di pecah per 100
                query.page = { number: 1, size: 100 };
                await this.$store.dispatch("fms_spj/list", query);
               var dataAll  = await this.$store.getters["fms_spj/list"]
                // console.log(dataAll)
                var pageMeta = await this.$store.getters["fms_spj/page"];
                // console.log(pageMeta['last-page'])
                //loop berdasarkan jumlah page
                if(pageMeta.total > 10000){
                  var count_100 = 1;
                  var part_count = 1;
                  var total_progress_start = pageMeta['last-page'];
                  var total_progress = 100;
                  var progress = 1;
                  var total_part = (!Number.isInteger(pageMeta.total/10000))?parseInt((pageMeta.total/10000).toFixed(0))+1:pageMeta.total/10000
                  for(let i=2; i < pageMeta['last-page'] + 1; i++){
                  
                  console.log('tahap '+i)
                  query.page = { number: i, size: 100 };
                  await this.$store.dispatch("fms_spj/list", query);
                  var dataloop = await this.$store.getters["fms_spj/list"]
                  dataAll = dataAll.concat(dataloop)

                  //update tampilan informasi di swal untuk memunculkan progress
                  let popupTextElement = document.getElementById("save-popup-message");
                   if(popupTextElement){
                    
                     let export_text = "Export "+part_count+"/"+total_part+" Part"
                     let export_percentage = (i/pageMeta['last-page']*100).toFixed(2)+"%"
                      popupTextElement.innerHTML = export_text+"</br> <progress  value='"+progress+"' max='"+total_progress+"'></progress>";
                   }
                   else{
                     //bagian ini terpanggil jika tombol cancel di swal tertekan
                     return
                   }
                   progress++;
                   count_100++;
                   if(count_100 == 100){
                    count_100 = 0;
                    this.fileName = "SPJ part"+part_count+".xls"
                    this.exportAllData = dataAll
                    const elem = this.$refs.btnDownloadAllFilteredExcell
                    elem.click()
                    
                    dataAll = []
                    part_count++;
                    total_progress_start = total_progress_start - 100
                    if((total_progress_start/100).toFixed(0) == 0){
                      total_progress = total_progress_start
                    }
                    else{
                       total_progress = 100
                    }
                    progress = 0
                   }

                }
                 this.fileName = "SPJ part"+part_count+".xls"
                this.exportAllData = dataAll
                //click tombol component export to excell
                
                this.SwallAllExport = Swal;
                const elem = this.$refs.btnDownloadAllFilteredExcell
                elem.click()
                }
                else{
                for(let i=2; i < pageMeta['last-page'] + 1; i++){
                  
                  console.log('tahap '+i)
                  query.page = { number: i, size: 100 };
                  await this.$store.dispatch("fms_spj/list", query);
                  var dataloop = await this.$store.getters["fms_spj/list"]
                  dataAll = dataAll.concat(dataloop)

                  //update tampilan informasi di swal untuk memunculkan progress
                  let popupTextElement = document.getElementById("save-popup-message");
                   if(popupTextElement){

                     let export_percentage = (i/pageMeta['last-page']*100).toFixed(2)+"%"
                      popupTextElement.innerHTML = "<progress  value='"+i+"' max='"+pageMeta['last-page']+"'></progress>";
                   }
                   else{
                     //bagian ini terpanggil jika tombol cancel di swal tertekan
                     return
                   }
                }
                this.exportAllData = dataAll
                
                this.SwallAllExport = Swal;
                //click tombol component export to excell
                const elem = this.$refs.btnDownloadAllFilteredExcell
                elem.click()
                

              }
            

            
    },

    async dataExportBefore(type) {
      if (this.table.length != 0) {
        if (type == "all") {
          await this.$store.dispatch("fms_spj/list");
          return this.dataExport(
            await this.$store.getters["fms_spj/list"]
          );
        } else if (type == "filter") {
          var query = {};

          // if(sortBy.length!=0){
          //   var  sort=sortBy[0]
          //   if(sortDesc[0]){
          //     sort="-"+sortBy[0]
          //   }
          //   query.sort = sort
          // }

          if (this.searchValue && this.searchCategory) {
                   if (query.filter) {
                    Object.assign(query.filter, {
                      [this.searchCategory]: this.searchValue,
                    });
                  } else {
                    query.filter = { [this.searchCategory]: this.searchValue };
                  }
                }

          if (this.valueStatus != "") {
            if (query.filter) {
              Object.assign(query.filter, { spj_status: this.valueStatus });
            } else {
              query.filter = { spj_status: this.valueStatus };
            }
          }

          if (this.valuePkoStatus != "") {
            if (query.filter) {
              Object.assign(query.filter, { pko_status: this.valuePkoStatus });
            } else {
              query.filter = { pko_status: this.valuePkoStatus };
            }
          }


          await this.$store.dispatch("fms_spj/list", query);
          return this.dataExport(
            await this.$store.getters["fms_spj/list"]
          );
        }
      }
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
    dataExport(data) {
      var dataReturn = [];
      data.forEach((value_1, index_1) => {
        var pko_status = "";
        if(value_1.spj_pko_data){
          if(value_1.spj_pko_data.current_status.status == 3){
            pko_status = "Active";
          }
          else if(value_1.spj_pko_data.current_status.status == 4){
            pko_status = "Payment Completed";
          }
          else if(value_1.spj_pko_data.current_status.status == 5){
            pko_status = "Terminate By Payment";
          }
         
        }
        var data = {
          no: index_1 + 1,
          // spj_business_unit : value_1.spj_pko_data.vehicle.vehicle_business_unit.business_unit_name,
          pko_no: value_1.spj_pko_data?value_1.spj_pko_data.pko_no:"",
          pko_status: pko_status,
          spj_no: value_1.spj_no,
          door_no: value_1.spj_pko_data.vehicle
            ? value_1.spj_pko_data.vehicle.vehicle_door_no
            : "",
          driver_no: value_1.spj_pko_data && value_1.spj_pko_data.driver
            ? value_1.spj_pko_data.driver.driver_no
            : "",
          driver_name: value_1.spj_pko_data && value_1.spj_pko_data.driver
            ? value_1.spj_pko_data.driver.driver_name
            : "",
          spj_weekly_installment: value_1.spj_weekly_installment,
          spj_penalty: value_1.spj_penalty,
          spj_total_payable:
            value_1.spj_weekly_installment + value_1.spj_penalty,
          payment_amount: value_1.payment_amount,
          spj_start_date: value_1.spj_start_date,
          spj_due_date: value_1.spj_due_date,
          spj_status: value_1.spj_current_status
            ? value_1.spj_current_status.status
            : "",
          spj_remarks: value_1.spj_remarks,
          created_at: value_1.created_at,
          updated_at: value_1.updated_at,
        };

        dataReturn.push(data);
      });
      if(this.SwallAllExport){
        this.SwallAllExport.close();
        this.SwallAllExport = null
      }
      return dataReturn;

      // console.log(data)
    },
  },
};
</script>
<style lang="scss" scoped>
#pro-feature {
  font-weight: bold;
}

.coba {
  width: 800px !important;
  margin: 50px auto !important;
  top: auto !important;
  bottom: auto !important;
  // height: 0% !important;

  @media screen and (max-width: 992px) {
    width: 90% !important;
  }
}
</style>
